<div #mainDiv_ll_model_cms_crosswalk>

  <!--<div *ngIf="bundle.showLocationEdit">-->
  <div [hidden]="!bundle.showLocationEdit">

    <div [style.top.px]="40" style="position:absolute;">

      <!--START/END DATES-->
      <div [style.width.px]="bundle.parentW" style="display: flex; align-items: center; gap: 10px; padding-top:0px; margin-left: 0px;">

        <!-- Included In Model -->
        <div style="display: flex; align-items: center; position: relative;">
          <div class="txtBold_12" style="margin-right: 10px;">
            Included In Model:
          </div>
          <div style="display: flex; gap: 10px;">
            <div *ngFor="let ac_eligible of bundle.eligibleChoices" style="font-size: 13px; font-family: Arial; line-height: 1;">
              <label style="display: flex; align-items: center; gap: 5px; margin: 0;">
                <input type="radio"
                       name="eligiblegroup"
                       [value]="ac_eligible.code"
                       [checked]="ac_eligible.SELECTED"
                       (change)="selectINCLUDEDYN($event)"
                       style="margin: 0; vertical-align: middle;">
                {{ac_eligible.choice}}
              </label>
            </div>
          </div>
          <img height="10"
               style="width: auto; cursor: pointer; margin-left: 5px; margin-top: -5px;"
               src="assets/infoBtn.png"
               alt="Tooltip Info"
               (mouseenter)="showTooltip_05 = true"
               (mouseleave)="showTooltip_05 = false">
          <div *ngIf="showTooltip_05"
               style="position: absolute; top: 12px; left: auto; right: 5px; width: 200px; padding: 5px; background-color: #f9f9f9; border: 1px solid #ccc; border-radius: 4px; font-size: 14px; z-index: 1000;">
            Excluding a location removes its collateral value from the model history, including the trend history and loan performance metrics. To avoid this, it’s recommended that a location be removed from the model by setting its “End date” to today. In this way the historic metrics for the model will continue reflecting the location up to the date its inclusion was ended.
          </div>
        </div>

        <!-- Bed Count -->
        <div style="display: flex; align-items: center; position: relative;">
          <!--<div class="txtBold_12" style="margin-right: 10px;">
            Bed Count:
          </div>-->
          <!--<div style="display: flex; align-items: center; gap: 12px; flex: 1;">
            <input type="text"
                   [ngModel]="formattedCommitmentAmt"
                   (input)="updateCommitmentAmt($event)"
                   class="form-input loan-commitment-input"
                   placeholder="e.g. 1,250,000"
                   style="flex: none;" />
            <span *ngIf="hasCommitmentChanged"
                  class="wordBtn_12"
                  (click)="saveCommitmentChange()">
              Save Change
            </span>
          </div>-->

        </div>

          <!-- Start Date -->
          <!--<div style="display: flex; align-items: center; gap: 10px;">
      <div class="txtBold_12">
        Start Date:
      </div>
      <div>
        <jqxDateTimeInput #date_STARTDATE
                          [width]="110"
                          [height]="17"
                          [formatString]="'d'"
                          (onChange)="selectStartDate()">
        </jqxDateTimeInput>
      </div>
    </div>-->
          <!-- End Date -->
          <!--<div style="display: flex; align-items: center; gap: 10px;">
      <div class="txtBold_12">
        End Date:
      </div>
      <div>
        <jqxDateTimeInput #date_ENDDATE
                          [width]="110"
                          [height]="17"
                          [formatString]="'d'"
                          (onChange)="selectEndDate()">
        </jqxDateTimeInput>
      </div>
    </div>-->
        </div>
      </div>

    <div [style.top.px]="70" style="position:absolute;">

      <div style="display: flex; gap: 20px;">
        <!-- Location Info -->
        <div>
          <!-- LOCATIONNAME -->
          <div style="display: flex; align-items: center; padding-top: 5px;">
            <div class="txtBold_12" style="width: 125px;">
              Billing Sys. Name:
            </div>
            <div class="txtNorm12" style="padding-left: 5px;">
              {{bundle.LOCATIONNAME}}
            </div>
          </div>

          <!-- PROVIDERNAME -->
          <div style="display: flex; align-items: center; padding-top: 5px;">
            <div class="txtBold_12" style="width: 125px;">
              Federal Name:
            </div>
            <div class="txtNorm12" style="padding-left: 5px;">
              {{bundle.PROVIDERNAME}}
            </div>
          </div>

          <!-- LEGALBUSINESSNAME -->
          <div style="display: flex; align-items: center; padding-top: 5px;">
            <div class="txtBold_12" style="width: 125px;">
              Fed. Legal Name:
            </div>
            <div class="txtNorm12" style="padding-left: 5px;">
              {{bundle.LEGALBUSINESSNAME}}
            </div>
          </div>

          <!-- ADDRESS -->
          <div style="display: flex; align-items: center; padding-top: 5px;">
            <div class="txtBold_12" style="width: 125px;">
              Address:
            </div>
            <div class="txtNorm12" style="padding-left: 5px;">
              {{bundle.ADDRESS}}
            </div>
          </div>
        </div>

        <!-- CMS Ratings -->
        <div>
          <!-- OverallStars and Tooltip -->
          <div style="display: flex; align-items: center; padding-top: 5px; position: relative;">
            <div class="txtBold_12" style="width: 140px;">
              CMS Overall:
            </div>
            <img style="height: 13px; width: auto;"
                 [src]="bundle.OVERALLRATING_STARIMAGE"
                 alt=""
                 onerror="this.style.display='none'">

            <img height="10"
                 style="width: auto; cursor: pointer; margin-left: 5px; margin-top: -5px;"
                 src="assets/infoBtn.png"
                 (mouseenter)="showTooltip_01 = true"
                 (mouseleave)="showTooltip_01 = false">
            <div *ngIf="showTooltip_01"
                 style="position: absolute; top: 12px; left: 138px; width: 200px; padding: 5px; background-color: #f9f9f9; border: 1px solid #ccc; border-radius: 4px; font-size: 14px; z-index: 1000;">
              The CMS Five-Star Quality Rating System rates nursing homes from 1 to 5 stars based on health inspections, staffing, and quality measures, with 5 stars indicating top quality.
            </div>
          </div>

          <!-- Health Inspection -->
          <div style="display: flex; align-items: center; padding-top: 5px; position: relative;">
            <div class="txtBold_12" style="width: 140px;">
              Health Inspection:
            </div>
            <img style="height: 13px; width: auto;" [src]="bundle.HEALTHINSPECTIONRATING_STARIMAGE" alt=""
onerror="this.style.display='none'">
            <img height="10"
                 style="width: auto; cursor: pointer; margin-left: 5px; margin-top: -5px;"
                 src="assets/infoBtn.png"
                 (mouseenter)="showTooltip_02 = true"
                 (mouseleave)="showTooltip_02 = false">
            <div *ngIf="showTooltip_02"
                 style="position: absolute; top: 12px; left: 138px; width: 200px; padding: 5px; background-color: #f9f9f9; border: 1px solid #ccc; border-radius: 4px; font-size: 14px; z-index: 1000;">
              The CMS Health Inspection Score evaluates nursing homes’ compliance with federal standards via state-conducted inspections, focusing on resident care and safety. Scores reflect the number and severity of deficiencies, significantly impacting the 1-to-5-star overall rating.
            </div>
          </div>

          <!-- Staffing -->
          <div style="display: flex; align-items: center; padding-top: 5px; position: relative;">
            <div class="txtBold_12" style="width: 140px;">
              Staffing:
            </div>
            <img style="height: 13px; width: auto;" [src]="bundle.STAFFINGRATING_STARIMAGE" alt=""
            onerror="this.style.display='none'">
            <img height="10"
                 style="width: auto; cursor: pointer; margin-left: 5px; margin-top: -5px;"
                 src="assets/infoBtn.png"
                 (mouseenter)="showTooltip_03 = true"
                 (mouseleave)="showTooltip_03 = false">
            <div *ngIf="showTooltip_03"
                 style="position: absolute; top: 12px; left: 138px; width: 200px; padding: 5px; background-color: #f9f9f9; border: 1px solid #ccc; border-radius: 4px; font-size: 14px; z-index: 1000;">
              The CMS Staffing Score rates nursing homes on nurse-to-resident ratios, adjusted for care needs, using self-reported and payroll data. Higher staffing, especially registered nurses, boosts the 1-to-5-star score, impacting the overall rating, with low staffing often yielding 1 or 2 stars.
            </div>
          </div>

          <!-- Staffing -->
          <div style="display: flex; align-items: center; padding-top: 5px; position: relative;">
            <div class="txtBold_12" style="width: 140px;">
              Quality Measure:
            </div>
            <img style="height: 13px; width: auto;" [src]="bundle.QMRATING_STARIMAGE" alt=""
            onerror="this.style.display='none'">
            <img height="10"
                 style="width: auto; cursor: pointer; margin-left: 5px; margin-top: -5px;"
                 src="assets/infoBtn.png"
                 (mouseenter)="showTooltip_04 = true"
                 (mouseleave)="showTooltip_04 = false">
            <div *ngIf="showTooltip_04"
                 style="position: absolute; top: 12px; left: 138px; width: 200px; padding: 5px; background-color: #f9f9f9; border: 1px solid #ccc; border-radius: 4px; font-size: 14px; z-index: 1000;">
              The CMS Quality Measure (QM) Rating, part of the Five-Star Quality Rating System for nursing homes, evaluates care quality based on 15 performance metrics: 6 for short-stay residents (e.g., rehabilitation patients) and 9 for long-stay residents (e.g., permanent residents). These metrics assess outcomes like pressure ulcers, falls, medication use, and functional status, using data from resident assessments.
            </div>
          </div>


        </div>
      </div>




      <!--INSTRUCTIONS AND BUTTON-->
      <div style="position:absolute;" [style.top.px]="bundle.grid_top - 80">
        <div style="clear: left; padding-top: 0px; border-top: 2px solid gainsboro;" [style.width.px]="bundle.parentW - 50"></div>

        <div style="padding-top: 10px;">

          <div class="txtBold_14" style="float: left; padding-top: 0px;">
            Enter criteria in boxes.
          </div>

          <div style="float: left; padding-left: 10px;">
            <div class="wordBtn14" (click)="search()">Click Here to Search</div>
          </div>

          <div class="txtBold_14" style="float: left; padding-left: 10px;">
            Click result row to select.
          </div>

        </div>
      </div>


      <div [style.width.px]="bundle.parentW" style="float: left; padding-top:5px;">
        <div style="position:absolute;" [style.top.px]="bundle.grid_top - 40">

          <!--search_Federal ID-->
          <div style="float: left;">

            <div class="txtSmallB" [style.width.px]="bundle.CMSCERTIFICATIONNUMBERCCN_W">
              Fed ID
            </div>

            <div (keyup)="onKeyUp($event)" style="clear: left; padding-top:2px;">
              <jqxTextArea #search_fedId [width]="bundle.CMSCERTIFICATIONNUMBERCCN_W" [height]="20"></jqxTextArea>
            </div>
          </div>

          <!--search_name-->
          <div style="float: left;">
            <div class="txtSmallB" [style.width.px]="bundle.PROVIDERNAME_W - 2">
              Provider Name
            </div>

            <div (keyup)="onKeyUp($event)" style="clear: left; padding-top:2px;">
              <jqxTextArea #search_name [width]="bundle.PROVIDERNAME_W - 2" [height]="20"></jqxTextArea>
            </div>
          </div>

          <!--legal_name-->
          <div style="float: left;">
            <div class="txtSmallB" [style.width.px]="bundle.LEGALBUSINESSNAME_W - 2">
              Legal Name
            </div>

            <div (keyup)="onKeyUp($event)" style="clear: left; padding-top:2px;">
              <jqxTextArea #search_legalName [width]="bundle.LEGALBUSINESSNAME_W - 2" [height]="20"></jqxTextArea>
            </div>
          </div>

          <!--search_address-->
          <div style="float: left;">
            <div class="txtSmallB" [style.width.px]="bundle.PROVIDERADDRESS_W - 1">
              Address
            </div>

            <div (keyup)="onKeyUp($event)" style="clear: left; padding-top:2px;">
              <jqxTextArea #search_address [width]="bundle.PROVIDERADDRESS_W - 1" [height]="20"></jqxTextArea>
            </div>
          </div>

          <!--search_city-->
          <div style="float: left;">
            <div class="txtSmallB" [style.width.px]="bundle.PROVIDERCITY_W - 2">
              City
            </div>

            <div (keyup)="onKeyUp($event)" style="clear: left; padding-top:2px;">
              <jqxTextArea #search_city [width]="bundle.PROVIDERCITY_W - 2" [height]="20"></jqxTextArea>
            </div>
          </div>

          <!--search_state -->
          <div style="float: left;">
            <div class="txtSmallB" [style.width.px]="bundle.PROVIDERSTATE_W - 1">
              State
            </div>

            <div (keyup)="onKeyUp($event)" style="clear: left; padding-top:2px;">
              <jqxTextArea #search_state [width]="bundle.PROVIDERSTATE_W - 1" [height]="20"></jqxTextArea>
            </div>
          </div>
        </div>

        <!--Search Results-->
        <div style="position:absolute;" [style.top.px]="bundle.grid_top">

          <jqxGrid #searchResults_DG
                   [editable]="true"
                   [rowsheight]="20"
                   [filterable]="true"
                   [sortable]="true"
                   [columnsresize]="true"
                   [showstatusbar]="false"
                   (onRowclick)="clickOnRow($event)">

          </jqxGrid>

        </div>


      </div>
    </div>
  </div>

